import { useState } from 'react';

import { InputLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledTextField = styled(TextField)`
    width: 572px;
`;
const StyledDiv = styled.div`
    margin-top: 12px;
`;

interface DescriptionInputProps {
    description: string;
    handleChange: (event: any) => void;
}

const DescriptionInput: React.FC<DescriptionInputProps> = ({ description, handleChange }) => {
    const { t } = useTranslation('admin_settings');
    const [changed, setChanged] = useState<boolean>(false);

    const handleDescriptionChange = (event) => {
        if (!changed) {
            setChanged(true);
        }
        handleChange(event);
    };

    return (
        <StyledDiv>
            <InputLabel>{t('api-keys.key-description')}</InputLabel>
            <StyledTextField
                size='small'
                name='description'
                value={description}
                onChange={handleDescriptionChange}
                placeholder={t('example')}
                error={!description && changed}
                helperText={t('api-keys.description-name-helper')}
            />
        </StyledDiv>
    );
};

export default DescriptionInput;
